import { createFileRoute } from '@tanstack/react-router';

export type { ExtraDataType } from './index.lazy';

export const Route = createFileRoute('/app/calendar-recurrence/')({});
